import React from 'react';
import '../interfaceSettings.css';
import { Outlet } from 'react-router-dom';

const AdminControlPanel = () => {
    return (
        <div className="container-xl bg-white">
            <div className="row my-3">
                <div className="col-12">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default AdminControlPanel;
